import styled from 'styled-components';

export const Container = styled.header`
  background-color: ${({ theme }) => theme.colors.background.white};
  width: 100%;
  height: 40px;
  border-bottom: 1px solid #cccbcc;

  display: flex;
  justify-content: space-between;

  padding: 5px 23px;

  span {
    white-space: nowrap;
  }

  .welcomeContainer {
    display: flex;
    gap: 64px;

    div {
      display: flex;
      gap: 16px;
    }
  }
`;

export const Button = styled.button`
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.colors.orange.primary};
  transition: 0.2s filter;

  &:hover {
    filter: brightness(0.8);
  }
`;

export const SelectContainer = styled.div`
  min-width: 180px;

  border: 1px solid #cccbcc;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.white};

  transition: border-color 0.2s, box-shadow 0.2s;

  &:focus-within {
    border-color: ${({ theme }) => theme.colors.orange.primary};
    box-shadow: 0 0 0 3px rgba(245, 128, 37, 0.15);
  }
`;
